<div class="flex items-center h-full px-2">
    <mat-select 
        class="text-sm pr-3"
        [ngClass]="selectedColumn?.undefined ? 'ignored-column' : ''"
        [(ngModel)]="selectedColumn" 
        (selectionChange)="onSelectionChange()"
        panelClass="header-select-panel">
        <mat-select-trigger>
            @if (this.selectedColumn?.undefined) {
                <div class="pt-1 flex flex-row">

                    <span>À définir</span>
                    <mat-icon class="smaller-icon ml-2">warning</mat-icon>
                </div>
            } @else {
                <div class="pt-1 flex flex-row">
                    <span>{{ selectedColumn?.name }}</span>
                    <!-- Add invisible icon to match alignement with undefined option that has an icon -->
                    <mat-icon class="invisible-icon"></mat-icon>
                </div>
            }
        </mat-select-trigger>
        @for (option of getOptions(); track option) {
            <mat-option [value]="option">
                <div class="flex flex-col">
                    <span class="font-medium">{{ option.name }}</span>
                    @if (!option?.ignored) {
                        <span class="text-xs text-gray-500">{{ option.example }}</span>
                    }
                </div>
            </mat-option>
        }
    </mat-select>
</div>